export const EXPORT_AES_TIP = '文件采用 AES-256 加密，请使用 7-Zip、WinRAR 或支持 AES ZIP 的解压工具打开。'
export const EXPORT_MAX_COUNT = 5000
export const EXPORT_POLL_INTERVAL = 3000
export const EXPORT_SUBMIT_COOLDOWN = 3000
export const EXPORT_RECORDS_PATH = '/teachers-and-students/export-records'

export type ExportDataType = 'STUDENT' | 'TEACHER'
export type ExportScope = 'SELECTED' | 'FILTERED'
export type ExportTaskStatus = 'GENERATING' | 'COMPLETED' | 'EXPIRED' | 'FAILED'
export type ExportSourceBackend = 'COMPANY' | 'ORGANIZATION'

export interface ExportEstimateRequest {
  dataType: ExportDataType
  filters: {
    orgId: string | number
  }
}

export interface ExportEstimateResult {
  orgName: string
  total: number
}

export interface CreateExportTaskRequest {
  dataType: ExportDataType
  ids?: Array<string | number>
  fields: string[]
  encryption: 'AES-256'
  orgId: string | number
}

export interface ExportTask {
  id: string | number
  taskId?: string | number
  orgId?: string | number
  exportNo?: string
  dataType: ExportDataType
  fileName?: string
  total?: number
  count?: number
  unzipPassword?: string
  status: ExportTaskStatus
  operatorName?: string
  orgName?: string
  source?: ExportSourceBackend | string
  createdTime?: string
  createTime?: string | number
  expireTime?: string
  downloadUrl?: string
  failureReason?: string
}

export interface ExportTaskListQuery {
  pageNum: number
  pageSize: number
  orgId?: string | number
  dataType?: ExportDataType
  status?: ExportTaskStatus
}
